/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGAModelBuilderOutputQueryVariables = {|
  modelID?: ?string
|};
export type PGAModelBuilderOutputQueryResponse = {|
  +pgaModelOutput: ?{|
    +columnNames: ?$ReadOnlyArray<?string>,
    +rows: ?$ReadOnlyArray<?{|
      +player: ?{|
        +id: string,
        +fullName: ?string,
        +firstName: ?string,
        +lastName: ?string,
        +nameDisplay: string,
        +nameShort: ?string,
        +dkPlayer: ?{|
          +id: string,
          +name: string,
        |},
      |},
      +salary: ?number,
      +totalModelScore: ?any,
      +totalModelRank: ?number,
      +values: ?$ReadOnlyArray<?{|
        +score: ?any,
        +stat: ?any,
        +rank: ?number,
        +featureName: ?string,
      |}>,
    |}>,
  |}
|};
export type PGAModelBuilderOutputQuery = {|
  variables: PGAModelBuilderOutputQueryVariables,
  response: PGAModelBuilderOutputQueryResponse,
|};
*/


/*
query PGAModelBuilderOutputQuery(
  $modelID: ID
) {
  pgaModelOutput(modelId: $modelID) {
    columnNames
    rows {
      player {
        id
        fullName
        firstName
        lastName
        nameDisplay
        nameShort
        dkPlayer {
          id
          name
        }
      }
      salary
      totalModelScore
      totalModelRank
      values {
        score
        stat
        rank
        featureName
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "modelID"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "modelId",
        "variableName": "modelID"
      }
    ],
    "concreteType": "PGATourModelTotalOutputType",
    "kind": "LinkedField",
    "name": "pgaModelOutput",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "columnNames",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PGATourModelTotalOutputRowType",
        "kind": "LinkedField",
        "name": "rows",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourPlayerType",
            "kind": "LinkedField",
            "name": "player",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nameDisplay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nameShort",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PlayerType",
                "kind": "LinkedField",
                "name": "dkPlayer",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "salary",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalModelScore",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalModelRank",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourModelTotalOutputRowValueType",
            "kind": "LinkedField",
            "name": "values",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "score",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stat",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rank",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "featureName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderOutputQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PGAModelBuilderOutputQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "b34abca0d0d853ec109847f9a0f947bc",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderOutputQuery",
    "operationKind": "query",
    "text": "query PGAModelBuilderOutputQuery(\n  $modelID: ID\n) {\n  pgaModelOutput(modelId: $modelID) {\n    columnNames\n    rows {\n      player {\n        id\n        fullName\n        firstName\n        lastName\n        nameDisplay\n        nameShort\n        dkPlayer {\n          id\n          name\n        }\n      }\n      salary\n      totalModelScore\n      totalModelRank\n      values {\n        score\n        stat\n        rank\n        featureName\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4467952ce2880a535547c6285f4d38ab';

module.exports = node;
